export const componentsEn = {
  pestAlerts: {
    title: "Official Real-Time Alerts",
    subtitle: "Alerts from phytosanitary agencies (INIA, SENASA, MAPA, IPPC, EPPO)",
    loadingAlerts: "Loading phytosanitary alerts...",
    noActiveAlerts: "No active alerts for your location and crop",
    newAlert: "🚨 New Phytosanitary Alert",
    affectedCrops: "Affected crops:",
    viewSource: "View official source",
    realtimeNote: "💡 Alerts update automatically in real-time using Supabase Realtime",
    errorLoading: "Could not load alerts"
  },
  changePassword: {
    title: "Change Password",
    description: "Enter your new password. Must be at least 6 characters.",
    newPassword: "New Password",
    confirmPassword: "Confirm New Password",
    minChars: "Minimum 6 characters",
    repeatPassword: "Repeat password",
    cancel: "Cancel",
    updating: "Updating...",
    changeButton: "Change Password",
    passwordUpdated: "Password updated",
    passwordUpdatedDesc: "Your password has been changed successfully",
    minLengthError: "New password must be at least 6 characters",
    mismatchError: "Passwords do not match",
    updateError: "Could not change password"
  },
  setPassword: {
    title: "Set your password",
    description: "Create a password to access your account in the future",
    newPasswordLabel: "New password",
    placeholder: "Enter your new password",
    mustHave: "Password must have:",
    min8Chars: "At least 8 characters",
    oneUppercase: "At least one uppercase letter",
    oneLowercase: "At least one lowercase letter",
    oneNumber: "At least one number",
    confirmLabel: "Confirm password",
    confirmPlaceholder: "Repeat your password",
    setButton: "Set Password",
    settingButton: "Setting...",
    checkingSession: "Checking session...",
    successTitle: "Password set!",
    successDesc: "You can now access the platform with your email and password.",
    errorSet: "Could not set password",
    validationMin8: "Password must be at least 8 characters",
    validationUppercase: "Must contain at least one uppercase letter",
    validationLowercase: "Must contain at least one lowercase letter",
    validationNumber: "Must contain at least one number",
    validationMismatch: "Passwords do not match"
  },
  pac: {
    loadingPac: "Loading PAC data...",
    title: "MAPA Data — Digital Agricultural Notebook",
    subtitle: "Royal Decree 1054/2022 — Mandatory fields for PAC inspection",
    compliant: "✓ Compliant",
    pendingFields: "{{count}} pending fields",
    ropoSection: "Phytosanitary Applicator (ROPO)",
    ropoNumber: "Applicator ROPO No. *",
    ropoExpiry: "ROPO Expiry Date",
    prescribedBy: "Treatment prescribed by phytosanitary advisor",
    productInfo: "Product Information",
    productRegNumber: "Product Registration No. (MAPA) *",
    activeSubstance: "Active Substance *",
    dosePerHectare: "Dose per Hectare (kg or L) *",
    safetyPeriod: "Safety Period (days) *",
    applicationDetails: "Application Details",
    applicationMethod: "Application Method *",
    applicationEquipment: "Application Equipment",
    select: "Select...",
    weatherConditions: "Weather Conditions",
    windSpeed: "Wind Speed (km/h)",
    temperature: "Temperature (°C)",
    humidity: "Humidity (%)",
    treatedArea: "Treated Area (ha) *",
    justification: "Treatment Justification *",
    saving: "Saving...",
    saveButton: "Save PAC Data",
    allFieldsComplete: "All mandatory MAPA fields completed",
    pendingFieldsCount: "{{count}} pending field(s)"
  },
  machinery: {
    selectParcelPlaceholder: "Select parcel",
    selectBrandPlaceholder: "Select brand"
  },
  worldCereal: {
    selectParcel: "Select Parcel",
    loadingParcels: "Loading parcels...",
    selectParcelOrManual: "Select a parcel or enter manually",
    enterManually: "✏️ Enter manually",
    myParcels: "MY PARCELS",
    noParcels: "You have no registered parcels.",
    addParcel: "Add a parcel",
    orEnterManually: "or enter data manually."
  },
  satelliteView: {
    imageUpdated: "Image updated",
    imageUpdatedDesc: "New image with official Copernicus palettes",
    updating: "Updating...",
    updateButton: "Update",
    eoUpdated: "EO data updated",
    eoUpdatedDesc: "EO Browser satellite image updated",
    updateError: "Update Error",
    updateErrorDesc: "Error updating EO Browser image."
  },
  batchExport: {
    exportComplete: "Export completed",
    exportCompleteDesc: "{{success}} images exported successfully",
    failedSuffix: ", {{failed}} failed",
    exportError: "Could not export any image",
    batchError: "Error during batch export"
  },
  irrigationReports: {
    generateFirst: "Generate your first report",
    selectParcelAndPeriod: "Select a parcel and period above to generate scientific irrigation data",
    dataIncludes: "Data includes FAO-56 calculations, optimal scheduling, economic analysis and AI-based recommendations",
    title: "Irrigation Decision Report",
    subtitle: "Generate a professional summary from saved irrigation recommendations, FAO-56 calculations and available satellite/weather records.",
    configuration: "Report Configuration",
    configurationDesc: "Select parcel and period to generate irrigation data",
    parcel: "Parcel",
    selectParcel: "Select parcel",
    period: "Period",
    periodDaily: "Daily (1 day)",
    periodWeekly: "Weekly (7 days)",
    periodMonthly: "Monthly (30 days)",
    generate: "Generate Report",
    generating: "Generating...",
    preview: "Preview",
    exportData: "Export Data",
    executiveSummary: "Executive Summary",
    dailyRequirement: "Reference crop water demand",
    
    waterStress: "Water Stress",
    currentNdvi: "Current NDVI",
    fao56Title: "FAO-56 Calculations",
    method: "Method",
    irrigationSchedule: "Irrigation Schedule",
    optimalHours: "Optimal hours",
    frequency: "Frequency",
    durationPerSession: "Duration per session",
    hour: "hour",
    hours: "hours",
    or: "or",
    alerts: "Alerts",
    priorityRecommendations: "Priority Recommendations",
    dataAvailability: "Data Availability",
    et0Points: "ET0 data points",
    ndviPoints: "NDVI data points",
    sufficientData: "Sufficient data",
    yes: "Yes",
    no: "No",
    noDataTitle: "No irrigation report data",
    noDataDesc: "No irrigation report data is available for this parcel and period yet. Run the Irrigation Optimizer first, or select a period with existing FAO-56/weather records.",
    missingFields: "Missing data",
    dataLimitedNotice: "Report generated from the latest saved irrigation recommendation. Some FAO-56 or satellite fields are unavailable for this period.",
    sourceSavedRec: "Report generated from the latest saved irrigation recommendation.",
    sourceDailyRecords: "Report generated from daily ET0/NDVI records.",
    dataLimitedDetail: "Data limited: daily ET0 and/or NDVI time-series records are not available for this period.",
    statusPanelTitle: "Report Status",
    reportSource: "Report source",
    dataStatus: "Data status",
    weatherSource: "Weather source",
    satelliteSource: "Satellite source",
    savedRecommendation: "Saved recommendation",
    dailyEt0Series: "Daily ET0 series",
    ndviRecord: "NDVI record",
    available: "Available",
    notAvailable: "Not available",
    waterStressMissing: "Not available — no NDVI/NDWI water-stress record found for this period.",
    ndviMissing: "Not available — no persisted Sentinel-2 NDVI record found for this period.",
    recommendationFromSaved: "Report generated from the latest saved irrigation recommendation. Additional priority recommendations require daily ET0 and satellite time-series data.",
    executiveRecommendation: "Executive Recommendation",
    referenceDemandTitle: "Reference crop water demand (ETc)",
    referenceDemandDisclaimer: "This is modelled crop evapotranspiration, not an irrigation amount to apply. No reviewed canonical irrigation application-target contract exists yet.",
    legacyRecommendationTitle: "Legacy irrigation recommendation",
    legacyRecommendationNote: "A historical legacy irrigation recommendation exists for this parcel. It is retained for audit only and is not current decision evidence.",
    
    partialDataDisclaimer: "This recommendation is based on the saved irrigation output and should be validated with field conditions.",
    unitConversions: "Unit conversions",
    perDay: "L/day",
    cubicPerDay: "m³/day",
    perHaPerDay: "L/ha/day",
    mmPerDay: "mm/day equivalent",
    fao56Components: "FAO-56 components",
    complete: "Complete",
    partial: "Partial",
    missing: "Missing",
    confidence: "Report confidence",
    confidenceHigh: "High",
    confidenceMedium: "Medium",
    confidenceLow: "Low",
    confidenceLimited: "Data limited",
    howToCompleteTitle: "How to complete this report",
    howToCompleteBody: "To complete NDVI and water-stress fields, run Satellite Intelligence → View Images or Generate NDVI History for this parcel and period. To complete daily ET0 records, run Irrigation Optimizer for the selected parcel and save the recommendation; daily ET0/ETc/Kc series are then populated by the FAO-56 dual-Kc pipeline.",
    metricSourcesTitle: "Metric sources",
    metricSourceDailyRequirement: "Daily requirement: calculated from FAO-56 ETc and parcel area.",
    metricSourceEt0: "ET0: FAO-56 calculation from weather data.",
    metricSourceEtc: "ETc: ET0 × Kc.",
    metricSourceKc: "Kc: crop coefficient used by the irrigation model.",
    metricSourceNdvi: "Current NDVI: persisted Sentinel-2 NDVI record.",
    metricSourceWaterStress: "Water Stress: derived from {{source}}.",
    metricSourceWaterStressEstimated: "Water Stress: estimated — no real NDWI/NDMI record persisted (data-limited).",
    metricSourceWaterIndex: "Satellite water index: descriptive {{source}} observation — not root-zone water stress.",
    metricSourceWaterIndexMissing: "Satellite water index: not available — no NDWI/NDMI record persisted for this period.",
    waterIndexTitle: "Satellite water index (NDWI/NDMI)",
    waterIndexDisclaimer: "Descriptive satellite water-index context — not root-zone water stress.",
    waterIndexMissing: "Not available — no NDWI/NDMI record persisted for this period.",
    applicationTargetTitle: "Irrigation application target",
    applicationTargetUnavailable: "No irrigation application amount is available: no reviewed canonical irrigation application-target contract exists.",
    reviewCanonicalWaterState: "Review current canonical water-state evidence.",
    waterStressEstimatedBadge: "Estimated",
    waterStressObservedBadge: "Satellite-observed",
    weatherRecords: "Weather records",
    exportNotAvailable: "Export is not available yet for this report.",
    exportOptions: "Export Options",
    exportOptionsDesc: "Download the data in your preferred format",
    forApisScripts: "For APIs and scripts",
    forSpreadsheets: "For Excel/Google Sheets",
    sendByEmail: "Send by email",
    useFor: "Use this data for:",
    useForPdf: "Create professional PDF reports in Canva, InDesign, etc.",
    useForExcel: "Import to Excel for custom analysis",
    useForBi: "Integrate with Google Data Studio or Power BI",
    useForAutomation: "Automate with Zapier, Make or your own scripts",
    useForClients: "Send to clients with your own branding",
    includedData: "Included data:",
    includedFao56: "FAO-56 scientific calculations",
    includedEconomic: "Full economic analysis",
    includedSchedule: "Optimal irrigation scheduling",
    includedConditions: "Current conditions (NDVI, NDWI)",
    includedForecast: "7-day forecast",
    includedHistorical: "30-day historical",
    includedAi: "AI recommendations",
    includedRiskAlerts: "Risk alerts"
  },
  canvasMasked: {
    fullSatelliteView: "Full Satellite View",
    couldNotGenerateMask: "(Could not generate parcel mask)",
    fullViewShown: "Satellite view shown",
    fullViewShownDesc: "Full image shown because parcel mask could not be generated"
  },
  issuePolicy: {
    parcel: "Parcel",
    selectParcel: "Select parcel",
    noParcels: "No parcels available"
  },
  aiModel: {
    loading: "Loading..."
  },
  regionalIntelligence: {
    status: "Status",
    noStoredNdvi: "No stored NDVI time-series record is available for this parcel. Recent Sentinel-2 imagery may exist, but it has not been persisted as an NDVI historical record yet.",
    openSatelliteImages: "Open Satellite Images to persist NDVI",
    recordsStored: "NDVI records stored: {{count}} / 4 required. At least one current NDVI record plus 3 previous records are needed to calculate anomaly.",
    openSatelliteImagesMore: "Open Satellite Images to persist more NDVI records"
  },
  leafletSentinel: {
    unknownError: "Unknown error",
    errorLoading: "Error loading {{type}}: {{msg}}",
    checkConnection: "Check your connection and try again",
    couldNotCreateCanvas: "Could not create canvas context",
    ndviNotLoaded: "NDVI image not fully loaded",
    zonesGeneratedNotSaved: "Zones generated but not saved to DB: ",
    errorSavingZones: "Error saving zones:"
  }
};
